import { FormFieldTypes } from "../../../data/formFieldType";

export const ViewApplicationTaskListData = {
  name: "AdditionalInfo",
  initialState: {
    companyNameOrUen: '',
    submittedFrom: null,
    submittedTo: null,
    channel: null,
    categoryL1: null,
    categoryL2: null,
    categoryL3: null,
    statusId: null,
  },
  formFields: [
    {
      id: "companyNameOrUen",
      lable: "Company Name or UEN",
      Field_Name: "Company Name or UEN",
      fieldType: FormFieldTypes.INPUT,
      dataField: "companyNameOrUen",
      fieldSetting: {
        placeholder: "",
        allowSpace: true,
      },
      style: {
        containerCss: "col-lg-4 mb-3",
      },
    },
    // {
    //   id: "",
    //   lable: "",
    //   Field_Name: "",
    //   fieldType: FormFieldTypes.MAINFORMTITLE,
    //   dataField: "",
    //   fieldSetting: {
    //     formTitle: "",
    //   },
    //   style: {
    //     containerCss: "col-lg-1 blank-column",
    //   },
    // },

    {
      id: "statusId",
      lable: "Status",
      Field_Name: "Status",
      fieldType: FormFieldTypes.SELECT,
      dataField: "statusId",
      fieldSetting: {
        placeholder: "Select",
        options: [],
      },
      style: {
        containerCss: "col-lg-4 mb-3",
      },
    },
    {
      id: "channel",
      lable: "Channel",
      Field_Name: "Channel",
      fieldType: FormFieldTypes.SELECT,
      dataField: "channel",
      fieldSetting: {
        placeholder: "Select",
        options: [],
      },
      style: {
        containerCss: "col-lg-4 mb-3",
      },
    },

    {
      id: "",
      lable: "",
      Field_Name: "",
      fieldType: FormFieldTypes.MAINFORMTITLE,
      dataField: "",
      fieldSetting: {
        formTitle: "",
      },
      style: {
        // containerCss: "col-lg-1 blank-column",
        containerCss: "col-lg-12 mb-12 blank-column",
      },
    },
    {
      id: "submittedFrom",
      lable: "Submitted From",
      Field_Name: "Submitted From",
      fieldType: FormFieldTypes.DATEPICKER,
      dataField: "submittedFrom",
      fieldSetting: {
        placeholder: "Select",
        // isTime: true,
        // isDisable:true,
      },
      style: {
        containerCss:
          "col-lg-2 mb-2",
      },
    },
    {
      id: "to",
      lable: "",
      Field_Name: "",
      fieldType: FormFieldTypes.MAINFORMTITLE,
      dataField: "to",
      fieldSetting: {
        formTitle: "to",
      },
      style: {
        containerCss: "date-range-to",
      },
    },
    {
      id: "submittedTo",
      lable: "Submitted To",
      Field_Name: "Submitted To",
      fieldType: FormFieldTypes.DATEPICKER,
      dataField: "submittedTo",
      fieldSetting: {
        placeholder: "Select",
        // isTime: true,
        // isDisable:true,
      },
      style: {
        containerCss:
          "col-lg-2 mb-2",
      },
    },
     {
      id: "",
      lable: "",
      Field_Name: "",
      fieldType: FormFieldTypes.MAINFORMTITLE,
      dataField: "",
      fieldSetting: {
        formTitle: "",
      },
      style: {
        containerCss: "col-lg-1 blank-column",
      },
    },

    {
      id: "categoryL1",
      lable: "L1",
      Field_Name: "L1",
      fieldType: FormFieldTypes.SELECT,
      dataField: "categoryL1",
      fieldSetting: {
        placeholder: "Select",
        options: [],
      },
      style: {
        containerCss: "col-lg-2 mb-3",
      },
    },
    {
      id: "categoryL2",
      lable: "L2",
      Field_Name: "L2",
      fieldType: FormFieldTypes.SELECT,
      dataField: "categoryL2",
      fieldSetting: {
        placeholder: "Select",
        options: [],
      },
      style: {
        containerCss: "col-lg-2 mb-3",
      },
    },
    {
      id: "categoryL3",
      lable: "L3",
      Field_Name: "L3",
      fieldType: FormFieldTypes.SELECT,
      dataField: "categoryL3",
      fieldSetting: {
        placeholder: "Select",
        options: [],
      },
      style: {
        containerCss: "col-lg-2 mb-3",
      },
    },

  ],
  formSetting: {
    isViewOnly: false,
  },
};

